export default {
    logout_prompt_title: "Logout",
    logout_prompt_message: "Is necessary to relogin to apply changes"
};

